export default {
      id: "icon--pound-small-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--pound-small-usage",
      toString: function () {
        return this.url;
      }
    }